import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ThemeContext } from '../../../../../auth';
import Swal from 'sweetalert2';
import { Button, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import { axiosAuth } from '../../../../../api';

function ModalUbahRole({
    rowSelected,
    showEditRole,
    setShowEditRole,
    retrieveRole,
    listDivisi,
    accessToken
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [selectedDivisi, setSelectedDivisi] = useState(null);
    const [defaultValueModal, setDefaultValueModal] = useState(false);
    const [listPermission, setListPermission] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowEditRole(false);
        setSelectedDivisi(null);
        retrievePermission();
    };

    const defaultValue = {
        roleName: rowSelected?.roleName || "",
        groupId: rowSelected?.group.id || "",
    };

    const divisiOptions = useMemo(() =>
        listDivisi.map(divisi => ({
            value: divisi.id,
            label: divisi.groupName,
        })), [listDivisi]);

    const handleSelectDivisi = (selectedOption, setFieldValue) => {
        setSelectedDivisi(selectedOption);
        setFieldValue('group.id', selectedOption ? selectedOption.value : null);
    };

    useEffect(() => {
        if (showEditRole) {
            const defaultSelected = divisiOptions.find(
                option => option.value === rowSelected?.group.id
            );

            if (defaultSelected) {
                setSelectedDivisi(defaultSelected);
            } else {
                setSelectedDivisi(null);
            }
            setDefaultValueModal(true);
        }
    }, [showEditRole, rowSelected, divisiOptions]);

    const retrievePermission = () => {
        axiosAuth.get(`/api/roles/${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListPermission(res.data.data.rolePermissions);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (rowSelected?.id !== undefined) retrievePermission();

    }, [rowSelected?.id]);

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const [checkboxes, setCheckboxes] = useState({});

    useEffect(() => {
        const initialCheckboxes = listPermission.reduce((acc, menu, index) => {
            acc[index] = {
                canRead: menu.canRead || false,
                canCreate: menu.canCreate || false,
                canUpdate: menu.canUpdate || false,
                canDelete: menu.canDelete || false,
                semua:
                    menu.canRead && menu.canCreate && menu.canUpdate && menu.canDelete,
            };
            return acc;
        }, {});
        setCheckboxes(initialCheckboxes);

    }, [listPermission]);

    const handleCheckboxChange = (event, rowIndex) => {
        const { id, checked } = event.target;

        setCheckboxes((prevCheckboxes) => {
            const updatedRow = {
                ...prevCheckboxes[rowIndex],
                [id]: checked,
            };

            if (id === 'semua') {

                updatedRow.canRead = checked;
                updatedRow.canCreate = checked;
                updatedRow.canUpdate = checked;
                updatedRow.canDelete = checked;
            } else {

                updatedRow.semua =
                    updatedRow.canRead &&
                    updatedRow.canCreate &&
                    updatedRow.canUpdate &&
                    updatedRow.canDelete;
            }

            return {
                ...prevCheckboxes,
                [rowIndex]: updatedRow,
            };

        });
    };

    const handleSubmitEdit = async (values) => {
        const finalPermissions = Object.keys(checkboxes).map((key) => ({
            groupMenuId: listPermission[key]?.groupMenuId,
            ...checkboxes[key],

        }));

        const finalData = {
            ...values,
            rolePermissions: finalPermissions
        };

        setIsSubmitting(true);
        setDisabled(true);

        try {

            const response = await axiosAuth.put(`/api/roles/${rowSelected?.id}`, finalData, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah Role',
                showConfirmButton: true,
            });
            retrieveRole();
            retrievePermission();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);
            handleClose();
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah Role',
            });
            setIsSubmitting(false);
            setDisabled(false);

        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        };
    };

    return (
        <Modal
            show={showEditRole}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Ubah Role
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitEdit}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='divisi'>Divisi*</Form.Label>
                                <Select
                                    id='divisi'
                                    options={divisiOptions}
                                    required
                                    value={selectedDivisi}
                                    onChange={option => handleSelectDivisi(option, setFieldValue)}
                                    isDisabled={true}
                                    styles={selectStyles}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='roleName'>Nama Role*</Form.Label>
                                <Form.Control
                                    id='roleName'
                                    type="text"
                                    value={values.roleName}
                                    onChange={handleChange("roleName")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahRole
